module.exports = __webpack_public_path__ + "static/media/overlay_splat4.30fc113b.gif";